import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/** Scroll window to top (instant, no animation). */
export function scrollWindowToTop(): void {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
}

function scrollToHashTarget(hash: string): void {
  const id = decodeURIComponent(hash.replace(/^#/, ''));
  if (!id) {
    scrollWindowToTop();
    return;
  }

  const scrollToEl = () => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'auto', block: 'start' });
    } else {
      scrollWindowToTop();
    }
  };

  requestAnimationFrame(() => {
    requestAnimationFrame(scrollToEl);
  });
}

/**
 * Scrolls to top on route changes and full page reloads.
 * Honors in-page hash links (e.g. /platform#platform-architecture).
 */
export function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
  }, []);

  useEffect(() => {
    if (hash) {
      scrollToHashTarget(hash);
      return;
    }
    scrollWindowToTop();
  }, [pathname, hash]);

  return null;
}
